import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// ----------------------------------------------------------------------

export function ButtonAnimated(t0) {
  const $ = _c(21);
  let audio;
  let iconAnimated;
  let other;
  let startIcon;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      audio,
      startIcon,
      iconAnimated,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = audio;
    $[2] = iconAnimated;
    $[3] = other;
    $[4] = startIcon;
    $[5] = text;
  } else {
    audio = $[1];
    iconAnimated = $[2];
    other = $[3];
    startIcon = $[4];
    text = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const [animations, setAnimations] = useState(t1);
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const newAnimation = {
        animation: true,
        id: Math.random(),
        x: Math.random() * 30
      };
      setAnimations(prevAnimations => [...prevAnimations, newAnimation]);
      setTimeout(() => setAnimations(prevAnimations_0 => prevAnimations_0.filter(animation => animation.id !== newAnimation.id)), 1500);
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClick = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      textWrap: "nowrap"
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== animations || $[10] !== audio || $[11] !== iconAnimated) {
    let t5;
    if ($[13] !== audio || $[14] !== iconAnimated) {
      t5 = animation_0 => <Box key={animation_0.id} className="floatUp__animation" sx={{
        left: animation_0.x
      }}>{iconAnimated}{audio && <audio controls={true} autoPlay={true} src={audio} style={{
          display: "none"
        }} />}</Box>;
      $[13] = audio;
      $[14] = iconAnimated;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = animations.map(t5);
    $[9] = animations;
    $[10] = audio;
    $[11] = iconAnimated;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[16] !== other || $[17] !== startIcon || $[18] !== t4 || $[19] !== text) {
    t5 = <Button size="small" variant="soft" onClick={handleClick} startIcon={startIcon} sx={t3} {...other}>{text}{t4}</Button>;
    $[16] = other;
    $[17] = startIcon;
    $[18] = t4;
    $[19] = text;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}